import React from "react"
import { Link } from "gatsby"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

import "./blog.css"

// const posts = require("../services/dataService").posts

const Template = ({
  pageContext,
  data: {
    allMarkdownRemark: { edges },
  },
}) => (
  <Layout>
    <SEO title="Blog" />
    <h1>Articles</h1>

    {edges.filter(p => p.node.frontmatter.published !== false).map(({ node: post }) => (
      <div className="post" key={post.id}>
        <Link to={getLink(post)}>{post.frontmatter.title}</Link>
        <div className="post-meta">{post.frontmatter.date || geFormattedDateFromFile(post.fileAbsolutePath)}</div>
        {/* <p>{post.excerpt}</p> */}
      </div>
    ))}
  </Layout>
)
const getLink = node => {
  const path = node.frontmatter.permalink || getSlugFromFile(node.fileAbsolutePath)
  return "/blog" + path
}

export default Template

export const pageQuery = graphql`
  query {
    allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          id
          excerpt(pruneLength: 250)
          fileAbsolutePath
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            permalink
            title
            published
          }
        }
      }
    }
  }
`

function getSlugFromFile(str) {
  const filename = str.replace(/^.*[\\\/]/, '');

  return "/" + filename.replace(getDateFromFile(filename) + "-", "");
}

function getDateFromFile(str) {
  const filename = str.replace(/^.*[\\\/]/, '');

  var date = `${filename.split('-')[0]}-${filename.split('-')[1]}-${filename.split('-')[2]}`

  return date;
}

function geFormattedDateFromFile(str) {
  var date = getDateFromFile(str)

  var options = { year: 'numeric', month: 'long', day: 'numeric' };
  var today = new Date(date);

  return (today.toLocaleDateString("en-US", options));
}